export default class LoaderTest {
  constructor() {
    this.test = document.querySelector(".jsLoaderTest");
    if (this.test) this.init();
  }

  init() {
    let testCounter = 100;

    const progress = setInterval(() => {
      this.test.style.transform = `translateX(-${testCounter}%)`;

      testCounter -= 10;
      if (testCounter < 0) {
        clearInterval(progress);
        this.test.parentElement.classList.add("loaded");
      }
    }, 150);
  }
}
